import { SUPPORTED_TRANSLATION_LANGUAGES } from '../../../config'
import type { LangCode } from '../../../types'

export function getSuggestedLanguage() {
  let suggestedLanguage = navigator.language.toLowerCase()

  if (suggestedLanguage && suggestedLanguage !== 'pt-br') {
    suggestedLanguage = suggestedLanguage.substr(0, 2)
  }

  if (!SUPPORTED_TRANSLATION_LANGUAGES.some((lang) => lang === suggestedLanguage)) {
    return 'en'
  }

  return suggestedLanguage as LangCode
}
